<h1 class="h1 text-primary">{{title}}</h1>
<p>{{description}}</p>
<input type="text" class="form-control" [formControl]="valueControl" />
<div class="d-flex">
  <app-button [disabled]="valueControl.invalid" class="ml-auto mt-1" (click)="close()">OK</app-button>
</div>
